// component
import Iconify    from '../../components/Iconify';
import * as React from 'react'
import { Trans }  from 'react-i18next'

// ----------------------------------------------------------------------

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

const navConfig = [
  {
    key: 'transactions',
    title: <Trans i18nKey={'Transactions'} />,
    path: '/transactions',
    icon: getIcon('material-symbols:receipt-long'),
  },
  {
    key: 'messages',
    title: <Trans i18nKey={'Messages'} />,
    path: '/messages',
    icon: getIcon('material-symbols:sms'),
  },
  {
    key: 'statistics',
    title: <Trans i18nKey={'Statistics'} />,
    path: '/statistics',
    icon: getIcon('material-symbols:bar-chart'),
    children: [
      {
        key: 'statistics/messages',
        title: <Trans i18nKey={'Message statistics'} />,
        path: '/statistics/messages',
        icon: getIcon('material-symbols:bar-chart'),
      },
      {
        key: 'statistics/transactions',
        title: <Trans i18nKey={'Transactions statistics'} />,
        path: '/statistics/transactions',
        icon: getIcon('material-symbols:bar-chart'),
      },
      {
        key: 'statistics/shares',
        title: <Trans i18nKey={'Shares statistics'} />,
        path: '/statistics/shares',
        icon: getIcon('material-symbols:bar-chart'),
      },
    ]
  },
  {
    key: 'services',
    title: <Trans i18nKey={'Services'} />,
    path: '/services',
    icon: getIcon('material-symbols:settings'),
  },
  {
    key: 'categories',
    title: <Trans i18nKey={'Categories'} />,
    path: '/categories',
    icon: getIcon('material-symbols:category'),
  },
  {
    key: 'partners',
    title: <Trans i18nKey={'Partners'} />,
    path: '/partners',
    icon: getIcon('material-symbols:partner-exchange'),
  },
  {
    key: 'operators',
    title: <Trans i18nKey={'Operators'} />,
    path: '/operators',
    icon: getIcon('material-symbols:signal-cellular-3-bar-rounded'),
  },
  {
    key: 'divider-0',
    divider: true,
  },
  {
    key: 'users',
    title: <Trans i18nKey={'Users'} />,
    path: '/users',
    icon: getIcon('material-symbols:groups-rounded'),
  },
  {
    key: 'sms-broadcast',
    title: <Trans i18nKey={'Sms broadcast'} />,
    path: '/sms-broadcast',
    icon: getIcon('material-symbols:campaign'),
  },
];

export default navConfig;
